import { Pipe, PipeTransform } from "@angular/core";
import { FlightsService } from "../../flights-calendar/flights.service";

@Pipe({
    name: "pilotName",
    standalone: false,
})
export class PilotNamePipe implements PipeTransform {
    constructor(private _flightsService: FlightsService) {}

    transform(pilotId: number): string {
        const pilotsArray = this._flightsService.getPilots();
        const pilotObj = pilotsArray.filter((pilot) => pilot.id === pilotId)[0];
        return !pilotObj ? "N/D" : pilotObj.firstName + " " + pilotObj.lastName;
    }
}
